import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../services/analytics';

// Hook pour initialiser et utiliser les analytics
export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialisation des services d'analytics
    analytics.initializeGA4();
    analytics.initializeClarity();
  }, []);

  useEffect(() => {
    // Suivi automatique des changements de page
    const pageTitle = document.title;
    const pagePath = location.pathname + location.search;
    
    analytics.trackPageView(pagePath, pageTitle);
  }, [location]);

  return {
    // Méthodes d'analytics disponibles dans les composants
    trackBookingAttempt: analytics.trackBookingAttempt.bind(analytics),
    trackBookingCompleted: analytics.trackBookingCompleted.bind(analytics),
    trackQuoteRequest: analytics.trackQuoteRequest.bind(analytics),
    trackContactForm: analytics.trackContactForm.bind(analytics),
    trackServiceInterest: analytics.trackServiceInterest.bind(analytics),
    trackEvent: analytics.trackEvent.bind(analytics),
  };
};
